
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '@/pages/Index';
import Auth from '@/pages/Auth';
import Dashboard from '@/pages/Dashboard';
import NotFound from '@/pages/NotFound';
import TripLayout from '@/components/trips/TripLayout';
import Itinerary from '@/pages/Itinerary';
import Expenses from '@/pages/Expenses';
import Group from '@/pages/Group';
import Memories from '@/pages/Memories';
import Travel from '@/pages/Travel';
import MyTrips from '@/pages/MyTrips';
import Assistant from '@/pages/Assistant';
import JoinPage from '@/pages/JoinPage';
import Profile from '@/pages/Profile';

// Using Routes/Route for BrowserRouter instead of createBrowserRouter
const router = (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/auth" element={<Auth />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/trips" element={<MyTrips />} />
    <Route path="/join" element={<JoinPage />} />
    <Route path="/assistant" element={<Assistant />} />
    <Route path="/profile" element={<Profile />} />
    
    {/* Nested trip routes */}
    <Route path="/trips/:tripId" element={<TripLayout />}>
      <Route index element={<Navigate to="itinerary" replace />} />
      <Route path="itinerary" element={<Itinerary />} />
      <Route path="travel" element={<Travel />} />
      <Route path="expenses" element={<Expenses />} />
      <Route path="group" element={<Group />} />
      <Route path="memories" element={<Memories />} />
      <Route path="assistant" element={<Assistant />} />
      <Route path="fun" element={<Navigate to="../itinerary" replace />} />
      <Route path="*" element={<NotFound />} />
    </Route>
    
    {/* Legacy routes for backward compatibility */}
    <Route path="/itinerary" element={<Itinerary />} />
    <Route path="/expenses" element={<Expenses />} />
    <Route path="/group" element={<Group />} />
    <Route path="/memories" element={<Memories />} />
    
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default router;
